import { useRoutes } from 'react-router-dom';

import { LandingPage } from './pages/LandingPage';
import { DocTypeSelect } from './pages/DocTypeOptionsPage';
import { FileUploader } from './pages/FileUploader';
import { UploadComplete } from './pages/UploadComplete';
import { Brands } from './types/types';
import { CreditorDocOptions } from './pages/CreditorOptionsPage';
import { IncomeDocOptions } from './pages/IncomeOptionsPage';

const brand = Brands[0];

export const AppRouter = () => {
    let routes = useRoutes([
        {
            path: "/", element: < LandingPage
                brand={brand.title}
                contactUsLink={brand.contactUsLink}
            />
        },
        {
            path: "/file-type",
            element: <DocTypeSelect />
        },
        {
            path: "/creditor-file-type",
            element: <CreditorDocOptions />
        },
        {
            path: "/income-file-type",
            element: <IncomeDocOptions />
        },
        {
            path: "/upload",
            element: <FileUploader />
        },

        {
            path: "/complete",
            element: <UploadComplete />
        }

    ]);
    return routes;
};